import { render } from "./EditMainSite.vue?vue&type=template&id=8f3890ce"
import script from "./EditMainSite.vue?vue&type=script&lang=js"
export * from "./EditMainSite.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ecommunity\\vms-admin.sg\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__